var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcCert(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 34,
    viewBox: "0 0 30 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2222_62)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2222_62)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.36239,
    y: 0.0833338,
    width: 23.2752,
    height: 29.8333,
    rx: 0.583336,
    fill: "#F3F3F3",
    stroke: "#EDEDED",
    strokeWidth: 0.166668
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.02148,
    y: 17.999,
    width: 17.9996,
    height: 1.19997,
    rx: 0.599985,
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.02148,
    y: 14.7996,
    width: 17.9996,
    height: 1.19997,
    rx: 0.599985,
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.02148,
    y: 21.2,
    width: 17.9996,
    height: 1.19997,
    rx: 0.599985,
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.02148,
    y: 24.4009,
    width: 12.7997,
    height: 1.19997,
    rx: 0.599985,
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4648 5.97784L15.0043 4.48169L11.4899 5.97784V7.71274C11.4899 8.71549 11.4036 9.76598 12.6075 11.3576C13.2431 12.198 14.4702 12.7052 15.0043 12.8538C15.4082 12.8007 16.4423 12.4272 17.3472 11.3576C18.4648 10.0366 18.4693 8.48204 18.4648 7.71274V5.97784Z",
    fill: "#3A7EFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5815 8.90243L14.5118 9.9877L16.5273 7.50708",
    stroke: "white",
    strokeWidth: 0.333335,
    strokeLinecap: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2222_62",
    x: -2,
    y: 0,
    width: 34,
    height: 34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2222_62"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2222_62",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2222_62",
    x: 2.94572,
    y: 0,
    width: 24.1086,
    height: 30.6667,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.333335
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.166668
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2222_62"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2222_62",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCert);
export default __webpack_public_path__ + "static/media/IcCert.c0a5772eda1f77552fa08c5e6d356a87.svg";
export { ForwardRef as ReactComponent };